<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <Button
      :disabled="disabled"
      :icon="{ left: `user-plus` }"
      @click="show = true"
      >Add Many User
    </Button>
    <Modal
      :className="$style.modal"
      label="Add a lot of External users"
      v-model="show"
    >
      The column delimiter is a tab OR comma character

      <form @submit.prevent="submit">
        <Stack direction="column" align="stretch" :class="$style.stack">

          <TextArea name="CSV" v-model="text" label="Paste CSV here" placeholder="First Name, Last Name, Email, Suffix"/>

          <Checkbox
            v-for="role of discordRoles"
            :options="discordRoles"
            v-model="roles[role]"
            :name="role"
            :label="role"
            :key="role"
          />

          <Button
            :icon="{ left: `user-plus` }"
            :loading="loading"
            >
            {{ user ? 'Update' : 'Add User' }}
          </Button>
        </Stack>
      </form>
    </Modal>
  </div>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Checkbox from '@hackthe6ix/vue-ui/Checkbox';
  import Input from '@hackthe6ix/vue-ui/Input';
  import Modal from '@hackthe6ix/vue-ui/Modal';
  import Select from '@hackthe6ix/vue-ui/Select';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextArea from '@hackthe6ix/vue-ui/Textarea';
  import swal from 'sweetalert';
  import 'vue-awesome/icons/user-plus';
  import { createObject, getObject } from '../../../../utils/api';
  import { discordRoles } from '../../../../utils/const';

  export default {
  name: 'AddExternalUser',
  props: {
    user: Object,
    updateUserCB: Function
  },
  data() {
    return {
      discordRoles,
      loading: false,
      show: false,
      roles: this.initRoles(),
      text: ''
    };
  },
  methods: {
    async addUser(updatedUser) {
      // Verify no other user has this email
      const checkDuplicateResult = await getObject('externaluser', {
        filter: {
          email: updatedUser.email
        }
      });
      if (checkDuplicateResult.success) {
        if (checkDuplicateResult.data.length > 0) {
          await swal('Unable to add user', 'It looks like this email is already registered', 'error');
          return false;
        }
      } else {
        await swal('Error', checkDuplicateResult.data, 'error');
        return false;
      }

      // Go ahead and make the new object
      const createUserResult = await createObject('externaluser', updatedUser);
      if (createUserResult.success) {
        await swal('Success', 'User has been added to the system', 'success');
      } else {
        await swal('Error', createUserResult.data, 'error');
        return false;
      }

      return true
    },
    async submit() {
      this.loading = true;

      const parsedUsers = this.text.split('\n').map(s => {
        s = s.split(/[\t,]/);

        return {
          email: s[2].toLowerCase().trim(),
          firstName: s[0].trim(),
          lastName: s[1].trim(),
          discord: {
            additionalRoles: Object.keys(this.roles).filter(role => this.roles[role]),
            suffix: s[3] || undefined
          }
        };
      });

      // confirm this is right

      const confirm = await swal({
        title: 'Confirm Addition',
        text: 'Are you sure you want to register these users?\n\n' + JSON.stringify(parsedUsers, null, 2),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      });

      if (confirm) {
        const results = await Promise.all(parsedUsers.map(user => this.addUser(user)));

        for (const result of results) {
          if (!result) {
            await swal('Error', result.data, 'error');
            return;
          }
        }

        this.show = false;
      }


      this.loading = false;
      window.location.reload();
    },
    initRoles() {
      return discordRoles.reduce((accumulator, role) => {
        const out = {};

        out[role] = false;

        return {
          ...accumulator,
          ...out
        }
      }, {})
    },
    updateLocalUser(user) {
      this.roles = user.discord.additionalRoles.reduce((accumulator, role) => {
        const out = {
          ...accumulator
        };

        out[role] = true;

        return out;
      }, this.initRoles()) || this.initRoles();

      this.firstName = user.firstName || '';
      this.lastName = user.lastName || '';
      this.suffix = user.discord.suffix || '';
      this.email = user.email.toLowerCase() || ''
    }
  },
  components: {
    TextArea,
    Input,
    Button,
    Select,
    Stack,
    Modal,
    Checkbox
  },
  watch: {
    show(s) {
      if (!s) {
        this.updateUserCB(null);
      }
    },
  }
};
</script>

<style lang="scss" module src="./AddBulkExternalUser.scss" />
